import debounce from "lodash/debounce";

const setHeights = (item) => {
  const neighbor = item.nextElementSibling;

  if (neighbor) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      const itemClone = item.cloneNode(true);
      itemClone.style.width = `${item.offsetWidth}px`;
      itemClone.style.position = "absolute";
      itemClone.style.opacity = 0;
      itemClone.style.top = "-1000px";
      itemClone.style.left = "-1000px";
      itemClone.querySelectorAll(".hidden").forEach((el) => el.classList.remove("hidden"));
      itemClone.querySelectorAll(".callout-spacer").forEach((el) => el.classList.add("hidden"));

      const neighborClone = neighbor.cloneNode(true);
      neighborClone.style.width = `${neighbor.offsetWidth}px`;
      neighborClone.style.position = "absolute";
      neighborClone.style.opacity = 0;
      neighborClone.style.top = "-1000px";
      neighborClone.style.left = "-1000px";
      neighborClone.querySelectorAll(".hidden").forEach((el) => el.classList.remove("hidden"));
      neighborClone.querySelectorAll(".callout-spacer").forEach((el) => el.classList.add("hidden"));

      document.body.appendChild(itemClone);
      document.body.appendChild(neighborClone);

      const maxHeight = Math.max(itemClone.offsetHeight, neighborClone.offsetHeight);

      item.style.setProperty("--spacer-height", `${Math.abs(itemClone.offsetHeight - maxHeight)}px`);
      neighbor.style.setProperty("--spacer-height", `${Math.abs(neighborClone.offsetHeight - maxHeight)}px`);

      document.body.removeChild(itemClone);
      document.body.removeChild(neighborClone);
    } else {
      item.style.setProperty("--spacer-height", "0px");
      neighbor.style.setProperty("--spacer-height", "0px");
    }
  }
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-expandablecalloutgrid .callout-item.odd").forEach((item) => setHeights(item));

  window.addEventListener(
    "resize",
    debounce(() => {
      document.querySelectorAll(".element-expandablecalloutgrid .callout-item.odd").forEach((item) => setHeights(item));
    }, 250),
  );
});
